export const atbCalculationOptions = [
    {
        label: 'Invoice create date',
        value: 'CreatedDate',
    },
    {
        label: 'Invoice due date',
        value: 'DueDate',
    },
];

export const enableTicketsOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
];

export enum AtbViewType {
    CalendarView = 'IsCalendarView',
    DueDateView = 'IsDueDateView'
};

export const atbPeriodOptions = [
    {
        label: '30, 60, 90+ days',
        value: '306090',
    },
    {
        label: 'Calendar month',
        value: 'CalendarMonth',
    },
];

export const groupATBbyParentSetting = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];

export const companyDisplayInformationOptions = [
    {
        label: 'include',
        value: 'include',
    },
    {
        label: "don't include",
        value: 'dont_include',
    },
];

export const companyImportTypes = {
    CLOUD: 'Cloud',
    API: 'API',
    EXCEL: 'Excel',
};

export const companyCloudImportTypes = {
    XERO: 'Xero',
    MYOB: 'MYOB'
};


export const companyApiImportTypes = {
    LEGACY: 'Legacy',
    IODM_CONNECT_WEB: 'IODM Connect Web',
};

export const accountingSystemOptions = {
    IODM_CONNECT_WEB_API: 'IODM Connect Web API',
    XERO: 'Xero',
    EXCEL: 'Excel',
    LEGACY_API: 'Legacy API',
    MYOB: 'MYOB'
};

export const accountingSystemSelectOptions = [
    {
        label: 'Connect via IODM Connect Web API',
        value: accountingSystemOptions.IODM_CONNECT_WEB_API,
    },
    {
        label: 'Connect via MYOB',
        value: accountingSystemOptions.MYOB,
    },
    {
        label: 'Connect via Xero',
        value: accountingSystemOptions.XERO,
    },
    {
        label: 'Import via Excel file',
        value: accountingSystemOptions.EXCEL,
    },
    {
        label: 'Import via Legacy API',
        value: accountingSystemOptions.LEGACY_API,
    }
];

export const hiddenCloudImportFields = ['CustomerCode', 'Customer code'];

export const customizationPlaceholders = {
    INFORM_US_LABEL: '{{INFORM_US_LABEL}}'
};

export const paymentPlanDepositTypeOptions = [
    {
        label: 'Percent',
        value: 'Percent',
    },
    {
        label: 'Set amount',
        value: 'Set amount',
    },
];

export const customFieldTypeOptions = [
    {
        label: 'Text',
        value: 'Text',
    },
    {
        label: 'Email',
        value: 'Email',
    },
    {
        label: 'Phone Number',
        value: 'PhoneNumber',
    },
    {
        label: 'Number',
        value: 'Number',
    },
    {
        label: 'Date',
        value: 'Date',
    },
    {
        label: 'Boolean',
        value: 'Boolean',
    },
];

export const customFieldFilterTypeOptions = [
    {
        label: 'Default',
        value: 'Default',
    },
    {
        label: 'Checkbox',
        value: 'Checkbox',
    },
];